<template>
	<v-card :key="product.product.id" class="mb-1" elevation="1">
		<v-list-item>
			<v-list-item-icon class="mr-3">
				<v-icon v-if="type == 'formula'" color="primary">mdi-spa</v-icon>
				<v-icon v-if="type == 'supplement'" color="primary">mdi-spa</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>
					<strong>{{product.product.name}}</strong>
					<v-tooltip top>
						<template v-slot:activator="{ on }">
							<v-btn class="ml-1" icon small @click="showProductInfo = true" v-on="on">
								<v-icon color="primary">info_outline</v-icon>
							</v-btn>
						</template>
						<span v-translate>Substance Info</span>
					</v-tooltip>
					<span v-if="context == 'new-product' && product.processing" class="ml-2 text-subtitle-2">{{product.processing.name}}</span>
					<span v-if="context == 'new-product' && product.info" class="ml-1 text-subtitle-2">({{product.info}})</span>
					<span v-if="context == 'new-product'" class="ml-2 text-subtitle-2">{{product.quantity}} {{product.unit}}</span>
				</v-list-item-title>
				<v-list-item-subtitle>
					<span
						class="font-italic"
						v-if="product.product.scientific_name"
					>{{product.product.scientific_name.charAt(0).toUpperCase() + product.product.scientific_name.slice(1)}}</span>
					<span class="ml-1" v-if="product.product.complex_substance" v-translate>
						Complex
					</span>
					<br />
					<v-row class="mt-2" no-gutters>
						<template v-if="product.product.substance_type">
							<v-icon
								v-if="product.product.substance_type.code == 'plant'"
								class="mr-1"
								small
								color="primary"
							>mdi-sprout</v-icon>
							<v-icon
								v-else-if="product.product.substance_type.code == 'mineral'"
								class="mr-1"
								small
								color="primary"
							>mdi-rhombus</v-icon>
							<v-icon
								v-else-if="product.product.substance_type.code == 'vitamin'"
								class="mr-1"
								small
								color="primary"
							>mdi-atom</v-icon>
							<span>{{product.product.substance_type.name}}</span>
						</template>
						<template v-if="product.product.plant_part">
							<span class="mx-1">|</span>
							<span>{{product.product.plant_part.name}}</span>
						</template>
						<v-spacer></v-spacer>
					</v-row>
				</v-list-item-subtitle>
				<v-row no-gutters v-if="product.product.complex_substance_unlisted">
					<v-col cols="12" no-gutters>
						<v-btn x-small fab class="ml-2" color="primary" @click="showSearchSubstance = !showSearchSubstance">
								<v-icon>mdi-plus</v-icon>
						</v-btn>
					</v-col>
					<v-col cols="12" no-gutters v-if="showSearchSubstance">
						<SearchProducts context="new-product" type="supplement" class="mt-1" :substance="true" @add-product="addSubstance" :availableProcessing="availableProcessing" />
					</v-col>
					<v-col v-if="product.ingredients && product.ingredients.length > 0" cols="12" md="12" class="mt-4">
						<SubstanceList
							:products="product.ingredients"
							context="new-product"
							type="supplement"
							@remove-product="removeSubstance"
							:availableProcessing="availableProcessing"
						/>
					</v-col>
				</v-row>
			</v-list-item-content>
			<v-list-item-action>
				<v-row no-gutters align="center">
					<v-tooltip v-if="context == 'new-product'" top>
						<template v-slot:activator="{ on }">
							<v-btn small icon @click="substanceQuantityDialog = true" v-on="on">
								<v-icon color="primary">edit</v-icon>
							</v-btn>
						</template>
						<span v-translate>Edit Quantity</span>
					</v-tooltip>
					<v-tooltip v-if="context == 'new-product'" top>
						<template v-slot:activator="{ on }">
							<v-btn small class="ml-2" icon @click="$emit('remove-product', product)" v-on="on">
								<v-icon color="primary">delete</v-icon>
							</v-btn>
						</template>
						<span v-translate>Remove</span>
					</v-tooltip>
					<v-dialog v-model="substanceQuantityDialog" max-width="40%" scrollable>
						<v-card>
							<v-card-title class="title primary--text mb-2 secondary" v-translate>Substance Quantity</v-card-title>
							<v-card-text>
								<v-form ref="substanceQuantityForm" v-model="substanceQuantityFormValid">
									<v-row no-gutters class="mt-3">
										<v-col cols="6">
											<v-text-field
												v-model="product.quantity"
												:label="product.product.name"
												class="px-2"
												outlined
												type="number"
											/>
										</v-col>
										<v-col cols="6">
											<v-select
												v-model="product.unit"
												:items="availableUnits"
												:label="$gettext('Unit')"
												item-text="name"
												item-value="code"
												outlined
												class="px-2"
											></v-select>
										</v-col>
									</v-row>
									<v-row no-gutters v-if="!product.product.complex_substance">
										<v-col cols="6">
											<v-select
												v-model="product.processing"
												:items="availableProcessing"
												:label="$gettext('Processing')"
												class="px-2"
												item-text="name"
												item-value="id"
												outlined
												return-object
											></v-select>
										</v-col>
										<v-col cols="6">
											<v-text-field
												v-model="product.info"
												:label="$gettext('Info')"
												class="px-2"
												outlined
											/>
										</v-col>
										<v-checkbox
											v-if="type != 'formula'"
											v-model="product.product.complex_substance_unlisted"
											class="mt-0 pt-0"
											color="primary"
											dense
											:label="$gettext('Complex')"
										>
										</v-checkbox>
									</v-row>
								</v-form>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="primary darken-1" text @click="substanceQuantityDialog = false">
									<translate>Save</translate>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
					<template v-if="context == 'settings' && $store.getters.spaceId == product.product.space_id">
						<v-tooltip v-if="context == 'settings'" top>
							<template v-slot:activator="{ on }">
								<v-btn icon :to="editProduct" v-on="on">
									<v-icon color="primary">edit</v-icon>
								</v-btn>
							</template>
							<span v-translate>Edit</span>
						</v-tooltip>
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn icon @click="showDeleteProduct = true" v-on="on">
									<v-icon color="primary">delete</v-icon>
									<DeleteConfirmationDialog v-model="showDeleteProduct" item="substance" @delete="removeProduct" />
								</v-btn>
							</template>
							<span v-translate>Remove</span>
						</v-tooltip>
						<v-chip small :color="product.product.last_edit_user.color" class="white--text mt-2" icon v-if="product.product.last_edit_user">
							{{product.product.last_edit_user.name}}
						</v-chip>
						<v-btn icon v-if="product.product.revision">
							<v-icon color="red">mdi-alert-circle-outline</v-icon>
						</v-btn>
					</template>
				</v-row>
			</v-list-item-action>
			<v-dialog v-model="showProductInfo" max-width="1000" scrollable>
				<v-card>
					<v-card-title class="title primary--text mb-2 secondary" v-translate>Substance Info</v-card-title>
					<v-progress-linear
						:active="loadingProductInfo"
						:indeterminate="loadingProductInfo"
						top
						color="primary"
					></v-progress-linear>
					<v-card-text v-if="!loadingProductInfo && type === 'supplement'" class="pt-2">
						<h3 class="primary--text" v-translate>General</h3>
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left" v-translate>Name</th>
										<th class="text-left" v-translate>Scientific Name</th>
										<th class="text-left" v-translate>Substance Type</th>
										<th
											v-if="product.product.substance_type.code == 'plant'"
											class="text-left"
											v-translate
										>Plant Part</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{ product.product.name }}</td>
										<td>
											<span
												v-if="product.product.scientific_name"
												class="font-italic"
											>{{ product.product.scientific_name.charAt(0).toUpperCase() + product.product.scientific_name.slice(1) }}</span>
											<span v-else v-translate>Not defined</span>
										</td>
										<td>
											<span v-if="product.product.substance_type">{{ product.product.substance_type.name }}</span>
											<span v-else v-translate>Not defined</span>
										</td>
										<td
											v-if="product.product.substance_type.code == 'plant' && product.product.plant_part"
										>{{ product.product.plant_part.name }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
						<v-row no-gutters v-if="product.product.complex_substance">
							<v-col cols="12" md="6" class="pr-5">
								<h3 class="my-4 primary--text" v-translate>Ingredients</h3>
								<p v-if="ingredients.length === 0" class="font-weight-thin ml-2" v-translate>No ingredients specified.</p>
								<template v-else>
									<!-- <p
										v-for="(ingredient, index) in ingredients"
										:key="index"
									>- {{ingredient.name}}
									<span v-if="ingredient.quantity > 0">
										({{ingredient.quantity}} {{ingredient.unit}})
									</span>
									</p> -->
									<div v-for="(ingredient, index) in ingredients" :key="index">
										<v-list-item dense class="pr-12">
											<v-list-item-content>
												<v-list-item-title>
													<v-row no-gutters>
													{{ingredient.product.name}}
													<template v-if="ingredient.processing">
														<span class="mx-1">|</span>
														<span>
															{{ingredient.processing.name}}
														</span>
														<span class="ml-1" v-if="ingredient.info">
															({{ingredient.info}})
														</span>
													</template>
													<v-spacer></v-spacer>
													{{ingredient.quantity}} {{ingredient.unit}}
													</v-row>
												</v-list-item-title>
												<v-list-item-subtitle v-if="ingredient.product.scientific_name">
													<span
														class="font-italic"
													>{{ingredient.product.scientific_name.charAt(0).toUpperCase() + ingredient.product.scientific_name.slice(1)}}</span>
												</v-list-item-subtitle>
											</v-list-item-content>
										</v-list-item>
									</div>
								</template>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col cols="12" md="6">
								<h3 class="my-4 primary--text" v-translate>Indications</h3>
								<p
									v-if="indications.length === 0"
									class="font-weight-thin ml-2"
									v-translate
								>No indications specified.</p>
								<template v-else>
									<p v-for="(indication, index) in indications" :key="index">- {{indication.title}}</p>
								</template>
							</v-col>
							<v-col cols="12" md="6">
								<h3 class="my-4 red--text" v-translate>Contra-Indications</h3>
								<p
									v-if="contraindications.length === 0"
									class="font-weight-thin ml-2"
									v-translate
								>No contra-indications specified.</p>
								<template v-else>
									<p
										v-for="(contraindication, index) in contraindications"
										:key="index"
									>- {{contraindication.title}}</p>
								</template>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-text v-if="!loadingProductInfo && type === 'formula'">
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left" v-translate>Name</th>
										<th class="text-left" v-translate>Pinyin</th>
										<th class="text-left" v-translate>Chinese Characters</th>
										<th class="text-left" v-translate>Latin Name</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{ product.product.name }}</td>
										<td>{{ product.product.pinyin_name }}</td>
										<td>{{ product.product.chinese_name }}</td>
										<td>{{ product.product.latin_name }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
						<template v-if="product.product.channels">
							<h4 class="mt-3" v-translate>Channels</h4>
							<p>{{product.product.channels}}</p>
						</template>
						<template v-if="product.product.properties">
							<h4 v-translate>Properties</h4>
							<p>{{product.product.properties}}</p>
						</template>
						<template v-if="product.product.temperature">
							<h4 v-translate>Temperature</h4>
							<p>{{product.product.temperature}}</p>
						</template>
						<template v-if="product.product.toxicity_overdose">
							<h4 v-translate>Chinese Herb Toxicity And Overdose</h4>
							<p>{{product.product.toxicity_overdose}}</p>
						</template>
						<template v-if="product.product.interactions">
							<h4 v-translate>Herb-Drug Interactions</h4>
							<p>{{product.product.interactions}}</p>
						</template>
						<template v-if="product.product.notes">
							<h4 v-translate>Chinese Herb Notes</h4>
							<p>{{product.product.notes}}</p>
						</template>
						<template v-if="product.product.actions">
							<h4 v-translate>Chinese Herb Actions</h4>
							<p>{{product.product.actions}}</p>
						</template>
						<template v-if="product.product.min_dosage || product.product.max_dosage">
							<h4 v-translate>Chinese Herb Dosage</h4>
							<p>{{product.product.min_dosage}} - {{product.product.max_dosage}}</p>
						</template>
						<template v-if="list_formulas.length > 0">
							<h4 v-translate>Appers in the Following Formulas</h4>
							<span class="mr-1" v-for="f in list_formulas" :key="f.name">{{f}};</span>
						</template>
						<v-row no-gutters>
							<v-col cols="12" md="6">
								<h3 class="my-4 primary--text" v-translate>Indications</h3>
								<p
									v-if="indications.length === 0"
									class="font-weight-thin ml-2"
									v-translate
								>No indications specified.</p>
								<p v-for="(indication, index) in indications" :key="index">- {{indication.title}}</p>
							</v-col>
							<v-col cols="12" md="6">
								<h3 class="my-4 red--text" v-translate>Contra-Indications</h3>
								<p
									v-if="contraindications.length === 0"
									class="font-weight-thin ml-2"
									v-translate
								>No contra-indications specified.</p>
								<p
									v-for="(contraindication, index) in contraindications"
									:key="index"
								>- {{contraindication.title}}</p>
							</v-col>
						</v-row>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary darken-1" text @click="showProductInfo = false">
							<translate>Close</translate>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-list-item>
	</v-card>
</template>

<script>
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
//import SubstanceList from "@/components/products/SubstanceList.vue";
import axios from "axios";

export default {
	name: "SubstanceItem",
	props: ["product", "type", "context", "admin", "availableProcessing"],
	components: {
		DeleteConfirmationDialog,
		SearchProducts: () => import("@/components/products/SearchProducts.vue"),
		SubstanceList: () => import("@/components/products/SubstanceList.vue")
	},
	data: () => ({
		posologyFormValid: false,
		showInteractionDrugs: false,
		showContraindications: false,
		showProductInfo: false,
		loadingProductInfo: true,
		substanceQuantityDialog: false,
		substanceQuantityFormValid: false,
		recommendation_quantity: {},
		ingredients: [],
		indications: [],
		contraindications: [],
		list_formulas: [],
		availableUnits: [
			{ name: "ug", code: "ug" },
			{ name: "mg", code: "mg" },
			{ name: "g", code: "g" }
		],
		showDeleteProduct: false,
		showSearchSubstance: false
	}),
	computed: {
		editProduct() {
			if (!this.admin) {
				if (this.type == "supplement") {
					return {
						name: "edit-product",
						params: { sid: this.product.product.id }
					};
				} else {
					return {
						name: "edit-substance",
						params: { sid: this.product.product.id }
					};
				}
			} else {
				if (this.type == "supplement") {
					return {
						name: "admin-edit-product",
						params: {
							sid: this.product.product.id,
							admin: true,
							language: "en"
						}
					};
				} else {
					return {
						name: "admin-edit-substance",
						params: {
							sid: this.product.product.id,
							admin: true,
							language: "en"
						}
					};
				}
			}
		}
	},
	methods: {
		validate() {
			return this.$refs.posologyForm.validate();
		},
		removeProduct() {
			this.$emit("remove-product", this.product);
		},
		editPosology(product) {
			if (this.validate()) {
				this.$emit("edit-posology", product);
			}
		},
		addSubstance(substance) {
			if (substance) {
				//if(!this.product.ingredients) this.product.ingredients = [];
				var exist = false;
				for (var i = 0; i < this.product.ingredients.length; i++) {
					if (this.product.ingredients[i].id == substance.product.id) {
						exist = true;
						break;
					}
				}
				if (!exist) {
					console.log("ADD SUBSTANCE");
					this.product.ingredients.push(substance);
					console.log(this.product.ingredients);
				}
			}
		},
		removeSubstance(substance) {
			this.product.ingredients.splice(this.product.ingredients.indexOf(substance), 1);
		}
	},
	watch: {
		showProductInfo() {
			if (this.showProductInfo && this.loadingProductInfo) {
				//CALL API
				var link = "";
				if (this.type === "supplement") link = "/product/";
				else link = "/mtc/substances/";
				axios
					.get(link + this.product.product.id + "/info")
					.then(response => {
						if (response.status === 200) {
							console.log(response.data);
							this.ingredients = response.data.ingredients;
							this.indications = response.data.indications;
							this.contraindications = response.data.contraindications;
							this.list_formulas = response.data.list_formulas;
							this.loadingProductInfo = false;
						}
					})
					.catch(error => console.log(error));
			}
		}
	}
};
</script>